<div class="px-3 md:px-10 xl:px-[175px] w-full max-w-[1920px] mx-auto">
  <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
    style="background: radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

  <div class="mt-[60px] relative text-[#222222] text-[40px] aspect43:text-center font-normal uppercase">
    <h1 class="text-[36px] leading-[40px] font-extrabold mb-2.5 text-center">
      Enti Pubblici
    </h1>
  </div>

  <div class="items-center mb-5 text-white font-normal text-[19px] aspect43:text-[26px] max-w-[100%] mx-auto flex">
    <div class="text-center text-justify-disabled mx-auto text-[24px] font-normal leading-[25px]">
      I nostri piani di abbonamenti sono distinti per imprese ed enti pubblici
    </div>
  </div>

  <div class="w-full bg-white rounded-[20px] shadow-lg p-5 xl:p-10">

    <div class="aspect43:flex">
      <div class="w-full border-[#222222]">

        <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
          <h2 class="!text-font24px">
            In Innovation Plaza, non vendiamo semplicemente l'accesso ai bandi; costruiamo la strategia finanziaria per
            il vostro futuro.
            La nostra politica di prezzo riflette un impegno totale verso la qualità e la sostenibilità dei progetti.
            Abbiamo scelto di
            differenziare i nostri servizi per rispondere con precisione millimetriche alle esigenze di due mondi
            distinti:
            le <strong>Imprese</strong>, dinamiche e orientate alla crescita, e le <strong>Pubbliche
              Amministrazioni</strong>, focalizzate
            sull’impatto territoriale e la conformità normativa.
          </h2>

          <div class="text-font32px font-semibold text-[#222222] mt-8">
            Sei un Ente Pubblico?
          </div>

          <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
            <h2 class="!text-font24px">
              La PA richiede continuità, presidio e una gestione rigorosa dei flussi documentali, specialmente nell’era
              del PNRR. La nostra politica di prezzo per gli Enti Pubblici si basa su
              <strong>canoni di assistenza tecnica</strong> o su incarichi professionali definiti per singoli obiettivi.
              Questo garantisce all’Amministrazione un supporto tecnico‑operativo costante, rispettando i limiti di
              spesa pubblica e assicurando
              una copertura professionale su tutto il ciclo di vita dei fondi.
            </h2>

            <div class="text-font32px font-semibold text-[#222222] mt-8">I nostri servizi per l’Ente Pubblico:</div>
            <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
              <h2 class="!text-font24px">
                Affianchiamo gli Enti Locali nell’intera catena del valore della finanza agevolata, garantendo la
                massima efficienza nella gestione delle risorse pubbliche.
              </h2>
              <br>

              <div class="text-font24px text-[#364349] font-semibold mb-4">
                Servizi di Fund-Raising &amp; Proposal Management
              </div>

              <div class="pl-1 mt-2 text-font24px font-medium text-[#364349] text-justify">
                <h4 class="!text-font24px mb-6 text-justify">
                  Non ci limitiamo a individuare l’opportunità, ma costruiamo l’architettura della proposta. Offriamo un
                  supporto specialistico per:
                </h4>
              </div>

              <ul class="list-disc pl-5 marker:text-blue-500 space-y-6 mb-12 ml-2 custom-marker">
                <li class="text-font24px text-[#364349] text-justify">
                  <strong>Networking e Partenariati:</strong>
                  Facilitiamo la creazione di reti solide tra Soggetti Partner e Capofila, elementi chiave per il
                  successo nei bandi complessi.
                </li>
                <li class="text-font24px text-[#364349] text-justify">
                  <strong>Proposal Management:</strong>
                  Gestiamo l’intera redazione della proposta progettuale, assicurando la coerenza tra obiettivi
                  politici
                  dell’ente e requisiti tecnici del bando.
                </li>
              </ul>

              <div class="text-font24px text-[#364349] font-semibold mb-4">
                Servizi di Project Management, coordinamento tecnico/amministrativo, Assistenza Tecnico‑specialistica al
                RUP
              </div>

              <div class="mt-2 text-font24px font-medium text-[#364349] text-justify">
                <h4 class="!text-font24px mb-6 text-justify">
                  La complessità amministrativa è la sfida principale per ogni Comune. Innovation Plaza funge da braccio
                  operativo per il Responsabile Unico del Progetto (RUP) attraverso:
                </h4>
              </div>

              <ul class="list-disc pl-5 marker:text-blue-500 space-y-6 mb-12 ml-2 custom-marker">
                <li class="text-font24px text-[#364349] text-justify">
                  <strong class="text-[#222222]">Project Management & Coordinamento:</strong>
                  Gestione tecnica e amministrativa costante per garantire il rispetto dei tempi e dei target
                  (milestones).
                </li>
                <li class="text-font24px text-[#364349] text-justify">
                  <strong class="text-[#222222]">Padronanza delle Piattaforme:</strong>
                  Operiamo con competenza certificata su tutti i principali sistemi di monitoraggio e rendicontazione
                  previsti dai vari Ministeri e dall'Europa, tra cui ReGiS, SGP, MIS, eMS, Jems, MIR e MIRWEB. La
                  nostra
                  assistenza garantisce che il dato inserito sia sempre conforme e a prova di audit.
                </li>
              </ul>

              <div class="text-font24px text-[#364349] font-semibold mb-4">
                Gestione dei Fondi Strutturali e delle Programmazioni Europee
              </div>

              <div class="pl-1 mt-2 text-font24px font-medium text-[#364349] text-justify">
                <h4 class="!text-font24px  mb-6 text-justify">
                  Supportiamo gli Enti nel delicato passaggio tra le diverse programmazioni finanziarie. Il nostro
                  servizio annuale di Assistenza Tecnica include:
                </h4>

                <ul class="list-disc pl-5 marker:text-blue-500 space-y-6 mb-12 ml-2 custom-marker">
                  <li class="text-font24px text-[#364349] text-justify">
                    <strong>Analisi costante dei fondi d’interesse:</strong> per gli Enti Locali (FESR, FSE+,
                    PNRR).
                  </li>
                  <li class="text-font24px text-[#364349] text-justify">
                    <strong>Supporto tecnico - specialistico:</strong> continuo per evitare il disimpegno dei fondi
                    e
                    assicurare la corretta chiusura dei progetti della passata programmazione e il lancio fluido della
                    nuova.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="mt-12 p-6 bg-gradient-to-r from-violet-50 via-indigo-50 to-purple-50 rounded-xl border-l-4 border-violet-500 mb-10">
            <div class="aspect43:flex place-content-center mt-10 gap-20">
              <div>
                <div class="text-[#222222] text-font24px font-bold mb-5 text-justify">
                  Per avere maggiori informazioni
                </div>
                <div (click)="goTo()"
                  class="my-5 w-full md:w-1/2 bg-purple-600 cursor-pointer rounded-full text-center p-4 text-font16px text-white font-semibold mx-auto hover:bg-purple-700 transition-colors">
                  CONTATTACI
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>